<script setup>
const props = defineProps({
  data: {
    type: Object,
    default: null
  },
})

</script>
<template>
  <div v-if="props.data">
    <q-chip
      size="sm"
      class="q-ma-none"
      text-color="white"
      :label="props.data?.name"
      :style="{
        backgroundColor: props.data?.color || '#999',
        opacity: props.data?.is_deleted ? 0.6 : 1,
        textDecoration: props.data?.is_deleted ? 'line-through' : 'none'
      }"
    />
  </div>
</template>
<style>
</style>
